import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

function getScoreColor(score: number): string {
	if (score >= 90) return '#dc2626'; // Red — reach out NOW
	if (score >= 70) return '#ea580c'; // Orange — good opportunity
	if (score >= 50) return '#ca8a04'; // Yellow — moderate
	if (score >= 30) return '#2563eb'; // Blue — low priority
	return '#6b7280'; // Gray — skip for now
}

interface ScoreIndicatorProps {
	score: number;
}

export const ScoreIndicator: React.FC<ScoreIndicatorProps> = ({ score }) => {
	return (
		<div className={css(styleSheet.scoreIndicator)} style={{ backgroundColor: getScoreColor(score) }}>
			{score}
		</div>
	);
};
